import { UseStream } from '@langchain/langgraph-sdk/react';

import { createContext, useContext } from 'react';

export const ChatContext = createContext<UseStream | null>(null);

export const useChatContext = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChatContext must be used within a ChatProvider');
  }
  return context;
};
